import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Agent } from '@amfam/shared/utility/agent';

@Component({
  selector: 'app-agent-confirmation',
  templateUrl: './agent-confirmation.component.html',
  styleUrls: ['./agent-confirmation.component.scss'],
  standalone: false
})
export class AgentConfirmationComponent {
  @Input() image: string;
  @Input() header: string;
  @Input() message: string;
  @Input() primaryButtonName: string;
  @Input() secondaryButtonName: string;
  @Input() agents: Agent[];

  @Output() primaryButtonClicked = new EventEmitter();
  @Output() secondaryButtonClicked = new EventEmitter();
}
